export default __webpack_public_path__ + "static/media/info_bg.66d5af9a.png";